/* ============================================================
   KINGS PLAY — patchy zip landing page behaviour
   Uses kp-global.js when present (kpAddVariant / kpRefreshCart /
   kpToast) and degrades to plain fetch + a local toast when not.

   This file NEVER touches the free tee. kp-global.js's reconciler
   owns the gift line end to end: it adds one when the cart holds
   both colourways and removes it the moment either one leaves.
   Adding a tee here would be untagged, so the reconciler could not
   clean it up, and removing a zip would strand a $35 line. One
   owner for the gift, everywhere.
   ============================================================ */
(function () {
  var d = document;
  if (!d.querySelector('[data-lp]')) return;

  var CFG = (function () {
    var el = d.querySelector('[data-lp-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  })();
  if (!CFG) return;

  var PREVIEW = !!CFG.preview;

  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  /* An element with id="kpToast" makes window.kpToast a reference to that
     element, so a truthiness check passes and the call throws. kp-global.js
     overwrites it with a real function but loads after this file — so always
     test callability, never existence. */
  function fn(x) { return typeof x === 'function' ? x : null; }

  function toast(m) {
    var g = fn(window.kpToast);
    if (g) return g(m);
    var t = $('#kpToast');
    if (!t) return;
    t.textContent = m; t.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }
  var sel = { black: null, grey: null };
  function card(key) { return $('[data-lp-panel="' + key + '"]'); }
  function err(key, msg) { var c = card(key); if (c) $('[data-lp-err]', c).textContent = msg || ''; }

  function setSize(key, size) {
    sel[key] = size;
    $$('[data-lp-size]', card(key)).forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-lp-size') === size);
      b.setAttribute('aria-pressed', b.getAttribute('data-lp-size') === size ? 'true' : 'false');
    });
    err(key, '');
    $('[data-lp-both-err]').textContent = '';
  }

  function needSize(key) {
    err(key, 'pick a size first');
    var c = card(key);
    var r = c.getBoundingClientRect();
    var onScreen = r.top >= 0 && r.bottom <= (window.innerHeight || document.documentElement.clientHeight);
    // both colourways sit side by side, so the card is usually already in
    // view — scrolling anyway just yanks the page out from under the tap.
    if (!onScreen) c.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var first = $('[data-lp-size]:not([disabled])', c);
    if (first) { try { first.focus({ preventScroll: onScreen }); } catch (e) { first.focus(); } }
  }

  /* ---------- swipe gallery ----------
     Scroll-snap does the swiping; this only mirrors position into the dots and
     stops a swipe from being read as a tap through to the PDP. */
  var galStart = new WeakMap();

  function syncDots(gal) {
    var dots = gal.parentElement.querySelector('[data-lp-dots]');
    if (!dots || !gal.clientWidth) return;
    var i = Math.round(gal.scrollLeft / gal.clientWidth);
    $$('button', dots).forEach(function (b, n) { b.classList.toggle('is-on', n === i); });
  }

  $$('[data-lp-gal]').forEach(function (gal) {
    var raf = 0;
    gal.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; syncDots(gal); });
    }, { passive: true });
    gal.addEventListener('pointerdown', function () { galStart.set(gal, gal.scrollLeft); }, { passive: true });
    gal.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      gal.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * gal.clientWidth, behavior: 'smooth' });
    });
    syncDots(gal);
  });

  /* ---------- cart ---------- */
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  // refresh repaints the drawer AND runs kp-global's gift reconciler, which is
  // what adds/removes the free tee — so always go through it after a mutation
  function done(msg) {
    var refresh = fn(window.kpRefreshCart);
    var p = refresh ? refresh(true) : Promise.resolve();
    return p.then(function () { if (msg) toast(msg); });
  }

  function addOne(key) {
    if (!sel[key]) return needSize(key);
    if (PREVIEW) return toast('preview only — add to bag works on the live store');
    addItems([{ id: Number(CFG[key].variants[sel[key]]), quantity: 1 }])
      .then(function () { return done('added to bag'); })
      .catch(function () { err(key, 'that size just sold out'); });
  }

  function addBoth() {
    if (!sel.black) return needSize('black');
    if (!sel.grey) return needSize('grey');
    if (PREVIEW) return toast('preview only — add to bag works on the live store');

    // The tee is deliberately NOT added here. kp-global.js owns the gift line:
    // it adds one when the cart qualifies and removes it the moment a colourway
    // leaves the bag. A tee added here would be untagged, so the reconciler
    // would never clean it up — stranding a $35 line the shopper didn't ask for
    // as soon as they removed a zip. One owner for the gift, everywhere.
    addItems([
      { id: Number(CFG.black.variants[sel.black]), quantity: 1 },
      { id: Number(CFG.grey.variants[sel.grey]), quantity: 1 }
    ])
      .then(function () { return done(); })
      .then(function () { return getCart(); })
      .then(function (cart) {
        // say what actually happened, rather than promising a tee that the
        // discount may not have granted
        var gift = cart.items.filter(function (it) {
          return it.properties && it.properties._kp_gift && it.final_line_price === 0;
        })[0];
        toast(gift ? 'both added — your free tee is in the bag' : 'both added to bag');
      })
      .catch(function () { toast('something went wrong — try again'); });
  }

  d.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-lp-dot]');
    if (dot) {
      e.preventDefault();
      var g = dot.closest('.lp-card__media').querySelector('[data-lp-gal]');
      if (g) g.scrollTo({ left: g.clientWidth * Number(dot.getAttribute('data-lp-dot')), behavior: 'smooth' });
      return;
    }

    // a swipe ends in a click on the slide — don't let it navigate to the PDP
    var slide = e.target.closest('.lp-gal__slide');
    if (slide) {
      var sg = slide.closest('[data-lp-gal]');
      var from = galStart.get(sg);
      if (from != null && Math.abs(sg.scrollLeft - from) > 8) { e.preventDefault(); return; }
    }

    var s = e.target.closest('[data-lp-size]');
    if (s) { e.preventDefault(); if (!s.disabled) setSize(s.closest('[data-lp-panel]').getAttribute('data-lp-panel'), s.getAttribute('data-lp-size')); return; }

    var one = e.target.closest('[data-lp-add]');
    if (one) { e.preventDefault(); if (!one.disabled) addOne(one.getAttribute('data-lp-add')); return; }

    if (e.target.closest('[data-lp-add-both]')) { e.preventDefault(); addBoth(); return; }
  });
})();
